export const benefits = [
  { icon: 'inventory_counts_benefit_1.svg', description: 'inventory_counts_benefit_1' },
  { icon: 'inventory_counts_benefit_2.svg', description: 'inventory_counts_benefit_2' },
  { icon: 'inventory_counts_benefit_3.svg', description: 'inventory_counts_benefit_3' },
  { icon: 'inventory_counts_benefit_4.svg', description: 'inventory_counts_benefit_4' },
  { icon: 'inventory_counts_benefit_5.svg', description: 'inventory_counts_benefit_5' },
];
